/* eslint-disable @typescript-eslint/no-explicit-any */
import IconClose from '@assets/icons/close.svg?react';
import {
 Box,
 Card,
 CardContent,
 IconButton,
 Typography,
 useTheme,
} from '@mui/material';
import dayjs from 'dayjs';
import {
 MutableRefObject,
 ReactNode,
 SetStateAction,
 useEffect,
 useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { usePage } from '../../../contexts/usePageContext';
import { PageNameType } from '../../../redux/clientConfiguration/clientConfigurationSlice';
import reduxSlicesList from '../../../redux/reduxSlicesList';
import { RootState } from '../../../redux/store';
import ResultInfoSidebar from '../../results/ResultInfoSidebar';
import { CustomGridApi } from '../XTable/types';
import CommonSidebar from './CommonSidebar';

interface TabPanelProps {
 children: ReactNode;
 index: number;
 value: number;
}

function a11yProps(index: number) {
 return {
  id: `info-tab-${index}`,
  'aria-controls': `info-tabpanel-${index}`,
 };
}

function CustomTabPanel(props: TabPanelProps) {
 const { children, value, index, ...other } = props;

 return (
  <div
   role="tabpanel"
   hidden={value !== index}
   id={`info-tabpanel-${index}`}
   aria-labelledby={`info-tab-${index}`}
   {...other}
  >
   {value === index && <Box sx={{ py: 2, px: 3 }}>{children}</Box>}
  </div>
 );
}

const InfoSidebar = ({
 apiRef,
 currentId,
 setCurrentId,
}: {
 apiRef: MutableRefObject<CustomGridApi>;
 currentId: number | undefined;
 setCurrentId: SetStateAction<any>;
}) => {
 const { pageName } = usePage();
 const { t } = useTranslation();
 const dispatch = useDispatch();
 const loaded = !!currentId;
 const [tab, setTab] = useState(0);
 const th = useTheme();
 const selector = useSelector((state: RootState) => state[pageName]);
 const { item, loading, success } = selector;
 //  console.log(currentId, result, loading);

 const [title, setTitle] = useState('');

 const handleClose = () => {
  setCurrentId(null);
 };

 const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  setTab(newValue);
 };

 useEffect(() => {
  if (currentId) {
   dispatch(
    reduxSlicesList[pageName as PageNameType]?.getItemStart({
     table: pageName,
     id: currentId,
    }),
   );
  }
 }, [currentId]);

 useEffect(() => {
  if (success.getItem) {
   if (pageName === 'results') {
    setTitle(dayjs(item?.Date).format('YYYY-MM-DD HH:mm'));
   } else if (item?.FullName) {
    setTitle(item?.FullName);
   } else if (item?.Name) {
    setTitle(item?.Name);
   } else if (item?.Number) {
    setTitle(item?.Number);
   } else {
    setTitle(t('global.data'));
   }
  }
 }, [success]);

 return (
  loaded && (
   <Box
    sx={{
     height: '100%',
     width: loaded ? { xs: '100%', md: '320px' } : '0px',
     //  overflowX: 'hidden',
     overflowY: 'auto',
     transition: 'all 0.2s ease-in-out',
     marginLeft: loaded ? { xs: '0px', md: '16px' } : '0px',
     position: 'relative',
    }}
   >
    <Card sx={{ minHeight: '100%' }}>
     <CardContent
      sx={{
       p: 0,
       fontSize: '12px',
       '&:last-child': {
        pb: 0,
       },
      }}
     >
      <Box
       sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: '20px',
        px: 3,
       }}
      >
       <Typography
        sx={{
         fontSize: { xs: 14, md: 16 },
         fontWeight: 500,
         lineheight: 'initial',
        }}
       >
        {title}
       </Typography>
       <IconButton
        onClick={handleClose}
        sx={{
         position: 'relative',
         p: 0,
         top: { xs: 0, md: -8 },
         right: { xs: 0, md: -8 },
        }}
       >
        <IconClose
         style={{ width: 20, height: 20, color: th.palette.kemek.darkestGray }}
        />
       </IconButton>
      </Box>
      {pageName === 'results' && (
       <ResultInfoSidebar apiRef={apiRef} item={item} />
      )}
      {['customers', 'vehicles', 'drivers', 'products'].includes(pageName) && (
       <CommonSidebar pageName={pageName} apiRef={apiRef} item={item} />
      )}
     </CardContent>
    </Card>
   </Box>
  )
 );
};
export default InfoSidebar;
